// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { SolidBrush } from '@shared/commons/Graphics';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
import { HistoryType } from '@shared/utils/History/HistoryType';
import { TerceraChartPriceScaleRenderer, TerceraChartPriceScaleRendererAligment, TerceraChartPriceScaleRendererWindowType } from './Renderers/Scales/TerceraChartPriceScaleRenderer';
import { TerceraChartMainPriceRenderer } from './Renderers/TerceraChartMainPriceRenderer';
import { TerceraChartCashItemSeriesSettings } from './Series/TerceraChartCashItemSeriesSettings';
import { TerceraChartOverlayWindow } from './TerceraChartOverlayWindow';
import { CashItemPointsCoverter } from './Utils/PointsConverter/CashItemPointsConverter';
import EventEmitter from 'events';
export class TerceraChartOverlay {
    constructor(chart) {
        this.separateScale = true;
        /// <summary>
        /// Рисовать маркеры или нет
        /// </summary>
        this.ShowMarker = true;
        this.ActiveInstrument = null;
        this.HistoryType = HistoryType.BID;
        this._eventEmitter = new EventEmitter();
        this.chart = chart;
        this.mainPriceRenderer = new TerceraChartMainPriceRenderer(this.chart);
        this.PriceScaleRenderer = new TerceraChartPriceScaleRenderer(chart, chart.yScaleRendererSettings, TerceraChartPriceScaleRendererWindowType.Overlay);
        this.PriceScaleRenderer.Aligment = TerceraChartPriceScaleRendererAligment.Left;
        this.window = new TerceraChartOverlayWindow(null, this.PriceScaleRenderer);
        this.window.Overlay = this;
        this.window.PointsConverter = new CashItemPointsCoverter(this.window, chart.mainPriceRenderer.Series);
        this.window.Renderers.push(this.mainPriceRenderer);
        this.PriceScaleRenderer.window = this.window;
        this.cashItemSeriesSettings = new TerceraChartCashItemSeriesSettings(chart.model);
        this.ThemeChanged();
    }
    SeparateScaleGet() {
        return this.separateScale;
    }
    SeparateScaleSet(value) {
        if (value != this.separateScale) {
            this.separateScale = value;
            if (this.separateScale) {
                this.window.AutoFit();
            }
        }
    }
    /// <summary>
    /// Параметры оверлея
    /// </summary>
    get Instrument() {
        return this.instrument;
    }
    set Instrument(fullInstrumentName) {
        this.instrument = fullInstrumentName;
        const instr = DataCache.getInstrumentByName(fullInstrumentName);
        this.ActiveInstrument = instr;
        this.PriceScaleRenderer.Instrument = instr;
        this.window.FmaxFloatY = this.window.FminFloatY = 0;
    }
    /// <summary>
    /// Style to draw chart
    /// </summary>
    ChartDrawingTypeGet() {
        return this.mainPriceRenderer.ChartDrawingType;
    }
    ChartDrawingTypeSet(value) {
        this.mainPriceRenderer.ChartDrawingType = value;
    }
    MarkerAndLineColorGet() {
        return this.mainPriceRenderer.barsLineColorPen.Color;
    }
    MarkerAndLineColorSet(value) {
        this.mainPriceRenderer.barsLineColorPen.Color = this.MarkerBrush.Color = value;
    }
    Dispose() {
        this._eventEmitter.emit('callerDisposed');
        this.chart = null;
        this.Instrument = null;
    }
    ThemeChanged() {
        this.mainPriceRenderer.ThemeChanged();
        this.MarkerBrush = new SolidBrush(this.mainPriceRenderer.barsLineColorPen.Color);
        this.PlateValueBrush = new SolidBrush(this.mainPriceRenderer.barsLineColorPen.Color);
        this.BidOverlayBrush = new SolidBrush(ThemeManager.colors.Chart_BidOverlayColor);
        this.AskOverlayBrush = new SolidBrush(ThemeManager.colors.Chart_AskOverlayColor);
        this.LastOverlayBrush = new SolidBrush(ThemeManager.colors.Chart_LastOverlayColor);
    }
    // TODO. Refactor.
    recalculateIndices() {
        const series = this.mainPriceRenderer.Series;
        if (series) {
            series.RecalcIndices();
        }
    }
    subscribeOnCallerClosed(callback) {
        this._eventEmitter.on('callerDisposed', callback);
    }
    unsubscribeOnCallerClosed(callback) {
        this._eventEmitter.off('callerDisposed', callback);
    }
}
